"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var moment = require("moment");
var react_redux_1 = require("react-redux");
var async_1 = require("react-select/async");
require("./style.scss");
var actions_1 = require("./actions");
var model_1 = require("../../model");
var constants_1 = require("../../constants");
var PortalPage_1 = require("../_shared/components/PortalPage");
var layout_1 = require("../_shared/components/layout");
var UserActions_1 = require("../userManagement/UserActions");
var UserTimeline_1 = require("../../model/UserTimeline");
var CalendarBar_1 = require("../_shared/components/calendarBar/CalendarBar");
var utils_1 = require("../../helpers/utils");
var ExcelExport_1 = require("../_shared/components/dataExport/ExcelExport");
var daysExportData = [];
var TimelinesPage = /** @class */ (function (_super) {
    __extends(TimelinesPage, _super);
    function TimelinesPage(props) {
        var _this = _super.call(this, props) || this;
        /** controls how many type columns to show */
        _this.getTypeConfigs = function () {
            return _this.state.type
                ? UserTimeline_1.timelineTypeConfigs.filter(function (typeConfig) { return typeConfig.type === _this.state.type; })
                : UserTimeline_1.timelineTypeConfigs;
        };
        _this.resetReportTable = function () {
            _this.props.resetReports();
            _this.updateExportData([]);
            _this.setState({ emptyReportsMsg: '' });
        };
        _this.handleTypeChange = function (e) {
            _this.setState({ type: e.currentTarget.value }, function () {
                _this.resetReportTable();
            });
        };
        _this.handleDateChange = function (dateFrom, dateTo) {
            _this.setState({ dateFrom: dateFrom, dateTo: dateTo }, function () {
                _this.resetReportTable();
            });
        };
        _this.handleUserInputChange = function (userSearchKeyword, meta) {
            if (meta.action !== 'set-value') {
                _this.setState({ userSearchKeyword: userSearchKeyword });
            }
        };
        _this.handleUserSelectChange = function (user) {
            var selectedUserIds = _this.state.selectedUsers.map(function (_a) {
                var _id = _a._id;
                return _id;
            });
            if (selectedUserIds.includes(user._id)) {
                return; // user already selected
            }
            _this.setState(function (prevState) { return ({ selectedUsers: __spreadArray(__spreadArray([], prevState.selectedUsers, true), [user], false) }); }, function () {
                _this.resetReportTable();
            });
        };
        _this.handleUserRemove = function (e) {
            var userId = e.currentTarget.getAttribute('data-userid');
            _this.setState(function (prevState) { return ({
                selectedUsers: prevState.selectedUsers.filter(function (user) { return user._id !== userId; })
            }); }, function () {
                _this.resetReportTable();
            });
        };
        _this.onGenerateReportClick = function () {
            _this.props.getReport(_this.state.dateFrom, _this.state.dateTo, _this.state.type, _this.state.selectedUsers.map(function (user) { return user._id; }));
            _this.setState({ emptyReportsMsg: React.createElement("p", null, "Geen rapportgegevens") });
            _this.updateExportData(daysExportData);
        };
        _this.updateExportData = function (exportData) {
            _this.setState({ exportData: exportData });
        };
        _this.loadUsersOptions = function (searchInput) { return __awaiter(_this, void 0, void 0, function () {
            var searchParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (searchInput.length < 3) {
                            return [2 /*return*/, []];
                        }
                        searchParams = {
                            filterText: searchInput,
                            pageSize: 10,
                            page: 0,
                            loadedLength: 0,
                            orderBy: [{ id: 'firstName', desc: false }]
                        };
                        return [4 /*yield*/, this.props.searchUsers(searchParams)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.props.usersState.users || []];
                }
            });
        }); };
        _this.uniqueRecords = function (inputArray) {
            return inputArray.reduce(function (acc, current) {
                if (current.type !== UserTimeline_1.IUserTimelineType.WORK_STATE && current.type !== UserTimeline_1.IUserTimelineType.GPS_STATE && current.type !== UserTimeline_1.IUserTimelineType.LOGIN_STATE) {
                    acc.push(current);
                }
                else {
                    var existingRecord = acc.find(function (item) {
                        if (item.type === current.type) {
                            var existingTimestamp = new Date(item.createdAt);
                            var currentTimestamp = new Date(current.createdAt);
                            existingTimestamp.setMilliseconds(0);
                            currentTimestamp.setMilliseconds(0);
                            return existingTimestamp.getTime() === currentTimestamp.getTime();
                        }
                        return false;
                    });
                    if (!existingRecord) {
                        acc.push(current);
                    }
                }
                return acc;
            }, []);
        };
        _this.uniqueGpsRecords = function (inputArray) {
            return inputArray.filter(function (item) { return item.type === UserTimeline_1.IUserTimelineType.GPS_STATE; });
        };
        _this.uniqueWorkRecords = function (inputArray) {
            return inputArray.filter(function (item) { return item.type === UserTimeline_1.IUserTimelineType.WORK_STATE; });
        };
        _this.uniqueLoginRecords = function (inputArray) {
            return inputArray.filter(function (item) { return item.type === UserTimeline_1.IUserTimelineType.LOGIN_STATE; });
        };
        _this.uniqueStartDayRecords = function (inputArray) {
            return inputArray.filter(function (item) { return item.type === UserTimeline_1.IUserTimelineType.START_WORKDAY; });
        };
        _this.uniqueEndDayRecords = function (inputArray) {
            return inputArray.filter(function (item) { return item.type === UserTimeline_1.IUserTimelineType.CLOSE_WORKDAY; });
        };
        _this.finalNonDuplicateArray = function (arr) {
            var filteredArr = [];
            var prevStatus = null;
            for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
                var item = arr_1[_i];
                if ((prevStatus === null && item.status === 'ON') ||
                    (prevStatus === null && item.status === 'OFF') ||
                    (prevStatus === 'ON' && item.status === 'OFF') ||
                    (prevStatus === 'OFF' && item.status === 'ON')) {
                    filteredArr.push(item);
                    prevStatus = item.status;
                }
            }
            return filteredArr;
        };
        _this.renderDailyReportTable = function (date, dayTimelines) {
            var dayExportData = { name: date, data: [] };
            var dayTimelinesUniqueRecords = _this.uniqueRecords(dayTimelines);
            var dayTimelinesUniqueGpsRecords = _this.uniqueGpsRecords(dayTimelinesUniqueRecords);
            var dayTimelinesUniqueWorkRecords = _this.uniqueWorkRecords(dayTimelinesUniqueRecords);
            var dayTimelinesUniqueLoginRecords = _this.uniqueLoginRecords(dayTimelinesUniqueRecords);
            var dayTimelinesUniqueStartDayRecords = _this.uniqueStartDayRecords(dayTimelinesUniqueRecords);
            var dayTimelinesUniqueEndDayRecords = _this.uniqueEndDayRecords(dayTimelinesUniqueRecords);
            var gps = _this.finalNonDuplicateArray(dayTimelinesUniqueGpsRecords);
            var work = _this.finalNonDuplicateArray(dayTimelinesUniqueWorkRecords);
            var login = _this.finalNonDuplicateArray(dayTimelinesUniqueLoginRecords);
            var combinedArray = gps.concat(work, login, dayTimelinesUniqueStartDayRecords, dayTimelinesUniqueEndDayRecords);
            var renderTableData = function (user, type, dUserTimelines) {
                var typeConfig = _this.getTypeConfigs().find(function (tConfig) { return tConfig.type === type; });
                return dUserTimelines
                    .filter(function (timeline) { return timeline.type === type; })
                    .map(function (timeline, index) {
                    var _a;
                    var _b;
                    var statusConfig = ((_b = typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.status) === null || _b === void 0 ? void 0 : _b[timeline.status]) || null;
                    var timelineItem = "".concat(moment(timeline.createdAt).format('HH:mm'), " ").concat(statusConfig === null || statusConfig === void 0 ? void 0 : statusConfig.text);
                    dayExportData.data.push((_a = {
                            'Gebruikersnaam': user.username,
                            'Volledige naam': (0, model_1.getUserFullName)(user)
                        },
                        _a[typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.title] = timelineItem,
                        _a));
                    return (React.createElement("div", { key: "table-type-data--".concat(date, "-").concat(type, "-").concat(index), className: "timeline-item" }, timelineItem));
                });
            };
            // sort in reverse chronological order
            combinedArray.sort(function (timeline1, timeline2) { return +new Date(timeline2.createdAt) - +new Date(timeline1.createdAt); });
            // group timelines by user
            var userTimelines = Object.values(combinedArray.reduce(function (acc, timeline) {
                var user = timeline.user;
                var userId = user._id;
                acc[userId] = acc[userId] || { user: user, timelines: [] };
                acc[userId].timelines.push(timeline);
                return acc;
            }, {}));
            daysExportData.push(dayExportData);
            return (React.createElement(layout_1.Wrapper, { paddingVertical: "10px", key: "table-wrapper--".concat(date) },
                React.createElement("span", { className: "timeline-date" }, moment(date).format(constants_1.DISPLAY_WEEKDAY_DATE_FORMAT)),
                React.createElement("table", { className: "border week-report-table" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { key: "table-header--".concat(date, "-username") }, "Gebruikersnaam"),
                            React.createElement("th", { key: "table-header--".concat(date, "-fullname") }, "Volledige naam"),
                            _this.getTypeConfigs().map(function (_a) {
                                var type = _a.type, title = _a.title;
                                return (React.createElement("td", { key: "table-header--".concat(date, "-").concat(type) }, title));
                            }))),
                    React.createElement("tbody", null, userTimelines.map(function (_a) {
                        var user = _a.user, timelines = _a.timelines;
                        return (React.createElement("tr", { key: "table-body-row--".concat(date, "-").concat(user._id) },
                            React.createElement("td", { key: "table-data--".concat(date, "-username") }, user.username),
                            React.createElement("td", { key: "table-data--".concat(date, "-fullName") }, (0, model_1.getUserFullName)(user)),
                            _this.getTypeConfigs().map(function (_a) {
                                var type = _a.type;
                                return (React.createElement("td", { key: "table-data--".concat(date, "-").concat(type), className: "timeline-data" }, renderTableData(user, type, timelines)));
                            })));
                    })))));
        };
        _this.state = {
            dateFrom: moment()
                .startOf('month')
                .format(constants_1.DATE_FORMAT),
            dateTo: moment().format(constants_1.DATE_FORMAT),
            type: '',
            userSearchKeyword: '',
            emptyReportsMsg: '',
            selectedUsers: [],
            exportData: []
        };
        return _this;
    }
    TimelinesPage.prototype.componentDidMount = function () {
        this.props.resetReports();
    };
    TimelinesPage.prototype.renderReportTables = function () {
        var _this = this;
        var reports = this.props.timelinesReportData;
        if (!reports || !reports.length) {
            return this.state.emptyReportsMsg;
        }
        var dateRange = (0, utils_1.getDateRange)(this.state.dateFrom, this.state.dateTo);
        return dateRange.map(function (date) {
            var dayReport = reports.find(function (report) { return report.date === date; });
            if (dayReport) {
                return _this.renderDailyReportTable(date, dayReport.timelines);
            }
            return null;
        });
    };
    TimelinesPage.prototype.render = function () {
        var _this = this;
        var canGenerateReport = this.state.selectedUsers.length > 0 && this.state.dateFrom && this.state.dateTo;
        var reportFileName = "Gebruikerstijdlijn ".concat(moment(this.state.dateFrom).format(constants_1.DISPLAY_WEEKDAY_DATE_FORMAT));
        if (this.state.dateTo !== this.state.dateFrom) {
            reportFileName += " to ".concat(moment(this.state.dateTo).format(constants_1.DISPLAY_WEEKDAY_DATE_FORMAT));
        }
        return (React.createElement(PortalPage_1.default, { page: model_1.Permission.PAGE_REPORT_TIMELINES, isLoading: this.props.isLoading, id: "report" },
            React.createElement(layout_1.Row, { justifyContent: "flex-end" },
                React.createElement("span", { className: "button report-back-button", onClick: function () { return _this.props.history.goBack(); } }, "Ga Terug")),
            React.createElement(layout_1.Wrapper, { paddingVertical: "20px" },
                React.createElement("table", { className: "report-input-table" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, "Tijdlijntype"),
                            React.createElement("th", { style: { minWidth: '200px' } }, "Gebruikers"),
                            React.createElement("th", null, "Begindatum"),
                            React.createElement("th", null, "Einddatum"),
                            React.createElement("th", null, ''))),
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("select", { name: "type", value: this.state.type, onChange: function (e) { return _this.handleTypeChange(e); }, className: "type-select" },
                                    React.createElement("option", { value: "" }, "Alles"),
                                    UserTimeline_1.timelineTypeConfigs.map(function (_a) {
                                        var type = _a.type, title = _a.title;
                                        return (React.createElement("option", { value: type, key: type }, title));
                                    }))),
                            React.createElement("td", null,
                                React.createElement(async_1.default, { value: null, loadOptions: function (e) { return _this.loadUsersOptions(e); }, placeholder: "Search user", getOptionValue: function (user) { return user._id; }, getOptionLabel: function (user) { return (0, model_1.getUserFullName)(user, true); }, onInputChange: this.handleUserInputChange, onChange: this.handleUserSelectChange, classNamePrefix: "user-select" })),
                            React.createElement("td", null,
                                React.createElement(CalendarBar_1.default, { locale: constants_1.DEFAULT_LANGUAGE, date: this.state.dateFrom, name: "dateFrom", max: moment(), onDateChange: function (date) { return _this.handleDateChange(date, _this.state.dateTo); } })),
                            React.createElement("td", null,
                                React.createElement(CalendarBar_1.default, { locale: constants_1.DEFAULT_LANGUAGE, date: this.state.dateTo, name: "dateTo", max: moment(), onDateChange: function (date) {
                                        return _this.handleDateChange(_this.state.dateFrom, date);
                                    } })),
                            React.createElement("td", { className: "button-cell" },
                                React.createElement("button", { className: "button".concat(!canGenerateReport ? ' button-disabled' : ''), onClick: function () { return _this.onGenerateReportClick(); }, disabled: !canGenerateReport }, "Rapport opstellen"))),
                        this.state.selectedUsers.length > 0 && (React.createElement("tr", null,
                            React.createElement("td", { colSpan: 5 }, this.state.selectedUsers.map(function (user) {
                                return (React.createElement("div", { className: "selected-user", key: user._id },
                                    React.createElement("span", { className: "selected-user--name" }, "".concat(user.firstName, " ").concat(user.lastName)),
                                    ' ',
                                    React.createElement("span", { className: "selected-user--remove", onClick: function (e) { return _this.handleUserRemove(e); }, "data-userid": user._id },
                                        React.createElement("i", { className: "material-icons" }, "cancel"))));
                            })))))),
                React.createElement(layout_1.Wrapper, { className: 'report-wrapper' },
                    React.createElement(layout_1.Margin, { margin: "15px" }),
                    React.createElement(ExcelExport_1.default, { sheets: this.state.exportData, fileName: reportFileName, bookType: "xlsx", buttonDisabled: this.props.timelinesReportData && this.props.timelinesReportData.length < 1 }),
                    this.renderReportTables()))));
    };
    return TimelinesPage;
}(React.Component));
var mapStateToProps = function (_a) {
    var reducer = _a.reducer;
    return {
        isLoading: reducer.reportReducer.isLoading,
        timelinesReportData: reducer.reportReducer.timelinesReportData,
        usersState: reducer.manageUsersState
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    getReport: function (dateFrom, dateTo, type, userIds) {
        return actions_1.Actions.getTimelinesReport(dateFrom, dateTo, type, userIds)(dispatch);
    },
    resetReports: function () { return actions_1.Actions.resetTimelinesReports()(dispatch); },
    searchUsers: function (searchParams) { return UserActions_1.UserActions.searchUsers(searchParams)(dispatch); }
}); };
var ReportTimelinesPage = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(TimelinesPage);
exports.default = ReportTimelinesPage;
